module.exports = __webpack_public_path__ + "img/addr.27c6d3ce.svg";